/**
 * Created by portiz on 8/15/2018.
 */
import React from 'react';
import {Card, CardBody, CardTitle, Col, CardImg, Container, Row, CardText} from 'reactstrap';
import {Link, Redirect} from "react-router-dom";

/** Multiple Language imports **/
import {withLocalize} from "react-localize-redux";
import {renderToStaticMarkup} from 'react-dom/server'; // Fix by the author. Do not remove even if it's not resolved
import {Translate} from "react-localize-redux";
import global from "../translations/global.json"
/** End of Multiple Language imports **/
import LanguageManager from '../custom-classes/language-manager';
import ImgChart from '../img/charts-01.png';
import ImgPrint from '../img/charts-02.png';
import ImgSyllabus from '../img/syllabus.png';
import TableSubscriptions from './tables/table-subscriptions';
import NavbarMobile from './navbar/navbar-mobile';
import NavbarDesktop from './navbar/navbar-desktop-top';
import Footer from './footer/footer';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faDesktop, faUser, faCogs, faList, faGamepad, faIdCard} from '@fortawesome/free-solid-svg-icons';
import Switch from "react-switch";
import TableActivity from './tables/table-activity';
import ApiCalls from '../custom-classes/api-calls';

/**
 * The component (window) to handle the client dashboard
 */
class Dashboard extends React.Component {

    constructor(props) {
        // Super is always called when defining the constructor of a subclass
        // All React component classes that have a constructor, should start it with a super(props) call.
        super(props);
        // To support language library add the following lines
        this.props.initialize({
            languages: [
                {name: "English", code: "en"},
                {name: "Español", code: "es"}
            ],
            options: {renderToStaticMarkup, defaultLanguage: LanguageManager.getLanguage()}
        });

        this.state = {
            subscriptionsData: null,
            navbarMobile: false,
            successfulRegistration: true,
            checked: false,
            sessionValid: true
        };
        this.handleChange = this.handleChange.bind(this);
        this.props.addTranslation(global);
    }

    /** Evaluate the resize, to show the proper navbar menu style*/
    componentDidMount() {
        window.addEventListener("resize", this.resize.bind(this));
        this.resize();
        this.checkIfMiniGamesAreEnable();
    }

    resize() {
        this.setState({navbarMobile: window.screen.width <= 1024});
    }

    /**
     * Check if mini games are enable
     */
    checkIfMiniGamesAreEnable(){
        // This is promise
        let apiCall = ApiCalls.getMiniGamesLock();

        // After the api call, fill the data
        apiCall.then((data)=> {
            console.log("Locked?", data.LockedGame);
          this.setState({checked: !data.LockedGame, sessionValid: data.SessionValid});
        });
    }

    /**
     * To turn on or off the locked video games area
     */
    handleChange() {

        this.setState({checked: !this.state.checked},()=>{
            // This is promise
            let apiCall = ApiCalls.insertMiniGamesLockCreate(!this.state.checked);

            // After the api call, fill the data
            apiCall.then((data)=> {
                this.setState({checked: !data.LockedGame });
            });
        })
    }



    /**
     * Renders the main dashboard
     * @returns {XML}
     */
    render() {
        if(this.state.sessionValid === null || typeof this.state.sessionValid === 'undefined')
            return (<Redirect  to={{
                pathname: "/login"
            }}/>);

        return (
            <div>
                {this.state.navbarMobile ? <NavbarMobile/> : <NavbarDesktop/>}
                <div className="container-padding">
                    <Container className="margin-top-mandatory-60">
                        <h2 className="font-now-bold white-text">
                            <FontAwesomeIcon icon={faDesktop}/>{' '}
                            <Translate id="dashboard.home" options={{renderInnerHtml: true}}/>
                        </h2>
                        <hr/>
                        <Row>
                            <Col lg={{size: 4}} md={{size: 4}} sm={{size: 12}} xs={{size: 12}}>
                                <Link to="/select-plan" className="centered-text white-text">
                                    <Card body className="card-orange">
                                        <CardTitle className="centered-text">
                                            <FontAwesomeIcon icon={faIdCard} size="2x"/>{' '}
                                        </CardTitle>
                                        <b><Translate id="dashboard.add-new-plan"
                                                   options={{renderInnerHtml: true}}/></b>
                                        <small><Translate id="dashboard.add-new-plan-subtitle"
                                                          options={{renderInnerHtml: true}}/></small>
                                    </Card>
                                </Link>
                            </Col>

                            <Col lg={{size: 4}} md={{size: 4}} sm={{size: 12}} xs={{size: 12}}>
                                <Link to="/profile-update" className="centered-text white-text">
                                    <Card body className="card-yellow">
                                        <CardTitle className="centered-text">
                                            <FontAwesomeIcon icon={faUser} size="2x"/>{' '}
                                        </CardTitle>
                                            <b><Translate id="dashboard.profiles-edit"
                                                       options={{renderInnerHtml: true}}/></b>
                                        <small><Translate id="dashboard.profiles-edit-subtitle"
                                                          options={{renderInnerHtml: true}}/></small>
                                    </Card>
                                </Link>
                            </Col>

                            <Col lg={{size: 4}} md={{size: 4}} sm={{size: 12}} xs={{size: 12}}>
                                <Link to="/update-information" className="centered-text white-text">
                                    <Card body className="card-green">
                                        <CardTitle className="centered-text">
                                            <FontAwesomeIcon icon={faCogs} size="2x"/>{' '}
                                        </CardTitle>
                                        <b><Translate id="dashboard.settings"
                                                      options={{renderInnerHtml: true}}/></b>
                                        <small><Translate id="dashboard.settings-subtitle"
                                                          options={{renderInnerHtml: true}}/></small>
                                    </Card>
                                </Link>
                            </Col>
                        </Row>

                        <Row>
                            <Col log={{size: 4}} md={{size: 4}} sm={{size: 12}} xs={{size: 12}}>

                                <Card className="card-red">
                                    <Link to="/report-average" className="btn btn-block btn-outline-light">
                                    <CardImg top width="100%" src={ImgChart} alt={ImgChart}/>
                                    <CardBody>
                                        <CardTitle><Translate id="dashboard.profile-analysis"
                                                              options={{renderInnerHtml: true}}/></CardTitle>
                                        <CardText><Translate id="dashboard.profile-analysis-subtitle"
                                                             options={{renderInnerHtml: true}}/></CardText>
                                    </CardBody>
                                    </Link>
                                </Card>

                            </Col>

                            <Col log={{size: 4}} md={{size: 4}} sm={{size: 12}} xs={{size: 12}}>
                                <Card className="card-blue">
                                    <Link to="/report-results" className="btn btn-block btn-outline-light">
                                        <CardImg top width="100%" src={ImgPrint} alt={ImgPrint}/>
                                        <CardBody>
                                            <CardTitle><Translate id="dashboard.results"
                                                                  options={{renderInnerHtml: true}}/></CardTitle>
                                            <CardText><Translate id="dashboard.results-subtitle"
                                                                 options={{renderInnerHtml: true}}/></CardText>
                                        </CardBody>
                                    </Link>
                                </Card>
                            </Col>

                            <Col log={{size: 4}} md={{size: 4}} sm={{size: 12}} xs={{size: 12}}>
                                <Card className="card-green-blue">
                                    <Link to="/syllabus" className="btn btn-block btn-outline-light">
                                        <CardImg top width="100%" src={ImgSyllabus} alt={ImgSyllabus}/>
                                        <CardBody>
                                            <CardTitle><Translate id="dashboard.syllabus"
                                                                  options={{renderInnerHtml: true}}/></CardTitle>
                                            <CardText><Translate id="dashboard.syllabus-subtitle"
                                                                 options={{renderInnerHtml: true}}/></CardText>
                                        </CardBody>
                                    </Link>
                                </Card>
                            </Col>

                            <Col lg={{size: 12}} md={{size: 12}} sm={{size: 12}} xs={{size: 12}}>
                                <Card body className="card-darker-transparency">
                                    <CardBody>
                                        <TableActivity activityData={this.state.lastActivityData}/>
                                    </CardBody>
                                </Card>
                            </Col>

                        </Row>


                        <h2 className="font-now-bold white-text margin-top-mandatory-60">
                            <FontAwesomeIcon icon={faGamepad}/>{' '}
                            <Translate id="dashboard.entertainment-games" options={{renderInnerHtml: true}}/>
                        </h2>
                        <hr/>
                        <Card className="card-dark-blue">
                            <CardBody>
                                <Row>
                                    <Col lg="10" md="10" sm="12" xs="12">
                                        <Translate id="dashboard.entertainment-games-instructions" options={{renderInnerHtml: true}}/>
                                    </Col>
                                    <Col lg="2" md="2" sm="12" xs="12">
                                        <Switch
                                            onChange={this.handleChange}
                                            checked={this.state.checked}  offColor="#f44256"
                                            id="normal-switch"
                                        />
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                        <Row>
                            <Col lg="12" sm="12" md="12" xs="12">
                                <h2 className="font-now-bold white-text margin-top-mandatory-60">
                                    <FontAwesomeIcon icon={faIdCard}/>{' '}
                                    <Translate id="subscriptions.my-subscriptions" options={{renderInnerHtml: false}}/>
                                </h2>
                                <hr/>
                                <TableSubscriptions/>
                                <Row>
                                    <Col lg="8" sm="8" md="8" xs="8"/>
                                    <Col lg="4" md="4" sm="12" xs="12">
                                        <Link data={this.state} to="/subscription-add-new" className="btn btn-warning btn-block">
                                            <Translate id="dashboard.add-new-subscriptions"
                                                       options={{renderInnerHtml: false}}/>
                                        </Link>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Container>
                </div>
                <Footer/>
            </div>

        )
    };
}

export default withLocalize(Dashboard);